export default (theme) => ({
  tableWrapper: {
    maxHeight: 300,
    overflow: "auto",
    border: "1px solid #e0dcdc",
  }
});
